<template>
  <section
    :class="['contact-info-wrapper', { 'has-padding': list.length === 1 }]"
  >
    <hr v-if="list.length > 1" />
    <div class="contact-info-item-wrapper">
      <div v-for="(item, idx) in list" :key="idx" class="contact-info-item">
        <template v-if="item.type === 'img-banner'">
          <div class="img-banner-item content-banner-item">
            <img-v3 :src="item.background_img_url" alt="" />
            <div class="title">
              <div
                class="tit-icon"
                :style="{
                  background: `url(${$getImageResizeUrl(item.title_icon)})`,
                  'background-size': 'cover',
                }"
              ></div>
              <div class="tit-text">{{ item.title }}</div>
              <div
                class="tit-icon"
                :style="{
                  background: `url(${$getImageResizeUrl(item.title_icon)})`,
                  'background-size': 'cover',
                }"
              ></div>
            </div>
            <div class="content-wrapper">
              <div
                class="content"
                v-for="(con, i) in item.content"
                :key="i"
                v-html="con"
              ></div>
            </div>
          </div>
        </template>
        <template v-else-if="item.type === 'frame-banner'">
          <div
            @click="handleClick(item)"
            class="frame-banner-item"
            :style="itemStyle(item)"
          >
            <span>{{ item.title }}</span>
          </div>
        </template>
        <template v-else-if="item.type === 'multi-content'">
          <div class="multi-content-item content-banner-item">
            <div class="title">
              <div
                class="tit-icon"
                :style="{
                  background: `url(${$getImageResizeUrl(item.title_icon)})`,
                  'background-size': 'cover',
                }"
              ></div>
              <div class="tit-text">{{ item.title }}</div>
              <div
                class="tit-icon"
                :style="{
                  background: `url(${$getImageResizeUrl(item.title_icon)})`,
                  'background-size': 'cover',
                }"
              ></div>
            </div>
            <div class="why-item" v-for="(con, i) in item.content" :key="i">
              <div
                class="con-top"
                :style="{
                  background: `url(${$getImageResizeUrl(con.bg_up_img_url)})`,
                  'background-size': '100% 100%',
                }"
              >
                <img-v3 :src="con.portrait_icon_url" alt="" />
                <p class="con-title">{{ con.title }}</p>
                <p class="con-sub-title">{{ con.sub_title }}</p>
              </div>
              <div class="con-body">
                <div
                  class="item-con"
                  v-for="(conItem, conI) in con.content"
                  :key="conItem + conI"
                  v-html="conItem"
                ></div>
                <img-v3 class="con-bottom-icon" :src="con.comma_bottom_img_url" alt="" />
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <img-v3
            :src="item.icon_url"
            alt=""
            v-if="item.icon_url && (!item.align || item.align === 'left')"
          />
          <a
            :href="linkHref(item)"
            @click="handleClick(item)"
            :style="itemStyle(item)"
            >{{ item.title }}</a
          >
          <img-v3
            :src="item.icon_url"
            alt=""
            v-if="item.icon_url && item.align === 'right'"
          />
        </template>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from "vuex";
import { IOS_MAP_URL, ANDROID_MAP_URL, ends } from "../../tools/constant";
import { showToast } from "../../tools/Tip";
export default {
  props: ["formItem", "phoneNumber", "policy"],
  mounted() {},
  computed: {
    ...mapState(["_ticket", "_area"]),
    list() {
      return this.formItem.list || [];
    },
    linkHref() {
      return (item) => {
        let _href = null;
        if (item.type === "phone-banner") {
          _href = `tel:${item.title}`;
        } else if (item.type === "mail-banner") {
          _href = `mailto:${item.title}`;
        } else if (item.link) {
          let url = item.link;
          let up = new URLSearchParams(location.search);
          if (this._ticket) {
            up.set("ticket", this._ticket);
          }
          if (up.get("from_end")) {
            up.delete("from_end");
          }
          if (url.indexOf("?") > -1) {
            url = `${url}&${up}`;
          } else {
            url = `${url}?${up}`;
          }
          _href = url;
        }
        return _href;
      };
    },
    itemStyle() {
      return (item) => {
        let fontSize = item.font_size ? item.font_size.split("px")[0] : "";
        return {
          color: item.font_color,
          "font-weight": item["font-weight"],
          ...(fontSize
            ? {
                "font-size": `${fontSize / 100}rem`,
              }
            : {}),
          ...(item.type === "frame-banner"
            ? { "border-color": item.font_color }
            : {}),
        };
      };
    },
  },
  methods: {
    outSideNav(item) {
      const { title } = item;
      const host = ends.isIOS ? IOS_MAP_URL : ANDROID_MAP_URL;
      const url = `${host}?daddr=${title}`;
      if (ends.isPC) {
        // 新打开一个tab，解决google X-Frame-Options的限制
        window.open(url, "_blank");
      } else {
        window.location.href = url;
      }
    },
    handleClick(item) {
      switch (item.type) {
        case "address-banner":
          if (ends.inApp) {
            const params = {
              toName: item.title,
              toLat: item.lat,
              toLng: item.lng,
            };
            try {
              Fusion.launchNav(params);
            } catch (e) {}
          } else {
            // 端外调起导航
            this.outSideNav(item);
          }
          Omega.trackEvent("ibt_gd_whatsapp_pull_up_ck", "", {
            type: "map",
          });
          break;
        case "phone-banner":
          Omega.trackEvent("ibt_gd_whatsapp_pull_up_ck", "", {
            type: "phone",
          });
          break;
        case "mail-banner":
          Omega.trackEvent("ibt_gd_whatsapp_pull_up_ck", "", {
            type: "mail",
          });
        case "banner":
          if (item.link && this.formItem.source === "whatsapp") {
            Omega.trackEvent("ibt_gd_whatsapp_toweb_register_ck");
          }
          break;
        case "frame-banner":
          this.doNoWALogin();
          Omega.trackEvent("ibt_gd_whatsapp_toweb_register_ck");
          break;
        default:
          break;
      }
    },
    doNoWALogin() {
      this.$emit('doLoginBr', 'noWA')
    },
  },
};
</script>
<style lang="scss" scoped>
.contact-info-wrapper {
  padding: 0 0.24rem;
  &.has-padding {
    padding: 0.48rem 0.4rem 0 0.4rem;
  }
  > hr {
    margin: 0;
    height: 0.02rem;
    background: #eeeeee;
    border: none;
  }
}
.contact-info-item-wrapper {
  padding: 0.48rem 0;
}
.contact-info-item {
  margin-bottom: 0.24rem;
  text-align: center;
  > img {
    width: 0.24rem;
    height: 0.24rem;
    margin-right: 0.08rem;
  }
  > a {
    font-weight: 400;
    font-size: 0.24rem;
    color: #333333;
    font-size: 0.24rem;
  }
}
.img-banner-item {
  position: relative;
  margin-top: 0.2rem;
  overflow: hidden;
  color: #333333;
  > img {
    width: 100%;
  }
  .title {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0.4rem;
    width: 100%;

    // word-wrap: break-word;
    // word-break: word-break;
    text-align: center;
    .tit-icon {
      margin: 0 0.16rem;
      width: 0.37rem;
      height: 0.23rem;
    }
    .tit-text {
      max-width: calc(100% - 1.46rem);
      font-size: 0.4rem;
      font-weight: 700;
    }
  }
  .content-wrapper {
    position: absolute;
    width: 100%;
    top: 1.23rem;
    padding: 0 0.32rem;
    box-sizing: border-box;
    text-align: left;
    .content {
      font-size: 0.28rem;
      line-height: 0.36rem;
      margin-top: 0.12rem;
      b {
        font-weight: 900;
      }
    }
  }
}
.multi-content-item {
  padding: 0.32rem 0;
  background: #fff;
  border-radius: 0.12rem;
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-align: center;
    .tit-icon {
      margin: 0 0.16rem;
      width: 0.37rem;
      height: 0.23rem;
    }
    .tit-text {
      max-width: calc(100% - 1.46rem);
      font-size: 0.4rem;
      font-weight: 700;
    }
  }
  .why-item {
    margin: 0.32rem;
    .con-top {
      display: flex;
      justify-content: center;
      flex-direction: column;
      position: relative;
      height: 0.93rem;
      padding-left: 1.68rem;
      > img {
        position: absolute;
        bottom: 0;
        left: 0.4rem;
        width: 1.06rem;
      }
      .con-title {
        margin-bottom: 0.04rem;
        font-size: 0.28rem;
        color: #000000;
      }
      .con-sub-title {
        font-size: 0.21rem;
        color: #999999;
      }
    }
    .con-body {
      position: relative;
      padding: 0.44rem 0.34rem 0.47rem 0.34rem;
      background: #f3f3f3;
      border-radius: 0 0 .12rem .12rem;
      .item-con {
        line-height: .32rem;
        font-size: 0.24rem;
        opacity: 0.7;
        color: #333333;
        text-align: left;
      }
      .con-bottom-icon {
        position: absolute;
        bottom: .2rem;
        right: .12rem;
        width: .45rem;
      }
    }
  }
}
.frame-banner-item {
  margin: 0 0.56rem;
  height: 0.72rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.12rem;
  border: 0.03rem solid;
  margin-top: 0.28rem;
}
</style>


